const config: {
	base_url: string;
	onlyOffice: string;
	result_code: number | string | boolean;
	default_headers: AxiosHeaders;
	request_timeout: number;
} = {
	base_url: '',
	onlyOffice: '',
	result_code: true,
	request_timeout: 120000,
	default_headers: 'application/json; charset=utf-8',
};

/* 开发环境 */
//config.base_url = 'http://10.10.7.52:2280';
// config.base_url = 'http://localhost:2280';
// config.onlyOffice = 'https://onlyoffice.voion.com';

// /* 测试环境 */
// config.base_url = 'https://contract-test.voion.com';
// config.onlyOffice = 'https://onlyoffice.voion.com';

// /* 正式环境 */
config.base_url = 'https://contract.voion.com';
config.onlyOffice = 'https://onlyoffice.voion.com';

export { config };
